import { useState } from "react";
import i18n from "../../../language/i18n";
import { SelectionTabPill, PrimaryButton } from "../../../library";
import { duelCreateFormStyles } from "./duelCreateFormStyles";

const ROUND_COUNT_OPTIONS = [3, 5, 10];
const TIME_LIMIT_OPTIONS = [
  { label: "15s", value: 15000 },
  { label: "20s", value: 20000 },
  { label: "30s", value: 30000 },
  { label: "45s", value: 45000 },
  { label: "60s", value: 60000 },
];

// The shared "Oyun Oluştur" form (rounds / time-per-round / who-can-join). Used by the duel arena's
// create-match modal and by the Friends-online "Meydan oku" challenge modal. Self-contained state; the
// caller only supplies defaults + an onSubmit(config) handler. Prefix: dcf-.
const DuelCreateForm = (props: {
  initialRoundCount?: number;
  initialTimeLimit?: number;
  initialIsPublic?: boolean;
  showVisibility?: boolean;
  submitLabel: string;
  submitting?: boolean;
  onSubmit: (config: { roundCount: number; timeLimit: number; isPublic: boolean }) => void;
}) => {
  const {
    initialRoundCount = 5,
    initialTimeLimit = 30000,
    initialIsPublic = true,
    showVisibility = true,
    submitLabel,
    submitting = false,
    onSubmit,
  } = props;
  const [roundCount, setRoundCount] = useState(initialRoundCount);
  const [timeLimit, setTimeLimit] = useState(initialTimeLimit);
  const [isPublic, setIsPublic] = useState(initialIsPublic);

  return (
    <div className="dcf-setup">
      <style>{duelCreateFormStyles}</style>
      <div className="dcf-setrow">
        <p className="dcf-setlbl">{i18n.t("rounds")}</p>
        <SelectionTabPill
          optionList={ROUND_COUNT_OPTIONS.map((count) => ({ id: count, title: `${count}` }))}
          selectedId={roundCount}
          handleSelectOnClick={(id) => setRoundCount(id)}
        />
      </div>
      <div className="dcf-setrow">
        <p className="dcf-setlbl">{i18n.t("time_per_round")}</p>
        <SelectionTabPill
          optionList={TIME_LIMIT_OPTIONS.map((option) => ({ id: option.value, title: option.label }))}
          selectedId={timeLimit}
          handleSelectOnClick={(id) => setTimeLimit(id)}
        />
      </div>
      {showVisibility ? (
        <div className="dcf-setrow">
          <p className="dcf-setlbl">{i18n.t("who_can_join")}</p>
          <div className="dcf-vis">
            <button
              type="button"
              className={`dcf-viscard${isPublic ? " is-on" : ""}`}
              onClick={() => setIsPublic(true)}
            >
              <span className="dcf-visic">🌍</span>
              <b>{i18n.t("visibility_public")}</b>
              <small>{i18n.t("visibility_public_desc")}</small>
            </button>
            <button
              type="button"
              className={`dcf-viscard${!isPublic ? " is-on" : ""}`}
              onClick={() => setIsPublic(false)}
            >
              <span className="dcf-visic">🔒</span>
              <b>{i18n.t("visibility_private")}</b>
              <small>{i18n.t("visibility_private_desc")}</small>
            </button>
          </div>
        </div>
      ) : null}
      <div className="dcf-setactions">
        <PrimaryButton
          title={submitLabel}
          size="medium"
          onClick={() => onSubmit({ roundCount, timeLimit, isPublic })}
          disabled={submitting}
        />
      </div>
    </div>
  );
};

export default DuelCreateForm;
